/**
 * Created by mukund on 12/4/16.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('LMSEmbedPlayController', function ($scope, $filter, $stateParams, $rootScope, $state, $window, $location, $http, Principal, CollectionService, BaseFileService, JobService, AssetService, atmosphereService) {
        Principal.identity().then(function (account) {
            $scope.account = account;
            $scope.job = null;
            $scope.errors = [];
            
            $scope.flagVjsPlayer = false;
            $http({method: 'GET', url: 'api/properties?name=FEATURE_FLAG_VJS_PLAYER'})
                .then(function (response) {
                    if (response.data.value !== null && response.data.value === "true") {
                        $scope.flagVjsPlayer = true;
                        //console.log("-------------Using VjsPlayer-------------\n");
                    }
                });
                
            var atmosphereSetup = function() {
                if(!$scope.account) {
                    return;
                }

                var request = {
                    url: './notification/'+$scope.account.login,
                    contentType: 'application/json',
                    logLevel: 'debug',
                    transport: 'websocket',
                    fallbackTransport: 'streaming',
                    trackMessageLength: true,
                    reconnectInterval: 5000,
                    enableXDR: true,
                    timeout: 300000,
                    shared: true
                };

                request.onOpen = function(response) {
                    console.log('Atmosphere connected using ' + response.transport);
                };

                request.onMessage = function(response) {
                    try{

                        var message = JSON.parse(response.responseBody);
                        $scope.batch = {progress: 0, transcodedCnt: 0};

                        if(message.messageType === 'notification') {
                            var batchSummary = message.messageBody,
                                transcodedCount = 0,
                                totalProgress = 0;
                            if($stateParams.batchId === batchSummary.id) {
                                batchSummary.jobSummary.forEach(function (job) {
                                    if (!$scope.job) {
                                        $scope.job = {progress: 0, status: "Processing file... ", canBePublished: true}
                                    }
                                    var tasksTerminated = 0;
                                    var canBePublished = false;
                                    job.tasks.forEach(function (task) {
                                        if (!(task.status === 'WAITING' || task.status === 'RUNNING' || task.status === 'REATTEMPTING')) {
                                            tasksTerminated++;
                                            if (task.taskType === 'TRANSCODE' && task.status === 'COMPLETED') {
                                                canBePublished = true;
                                            }
                                        }
                                    });
                                    $scope.job.progress = job.progress;
                                    if (job.progress === 100 || (tasksTerminated !== 0 && tasksTerminated === job.tasks.length)) {
                                        if (job.progress !== 100) {
                                            $scope.job.progress = 100;
                                            $scope.job.canBePublished = canBePublished;
                                            if (!canBePublished) {
                                                $scope.job.status = "File processing failed, with fatal error during transcode";
                                                $scope.errors.push({
                                                    code: Errors.TRANSCODE,
                                                    msg: "A fatal error occurred while transcoding a file in the batch. Please try again later or contact your ShareStream Administrator if the error persists."
                                                });
                                                // Redirect to error page here
                                            } else {
                                                $scope.job.status = "File processing complete, but with some non-fatal errors";
                                            }
                                        }
                                        else {
                                            $scope.job.status = "File processing complete";
                                            $scope.job.canBePublished = canBePublished;
                                        }
                                        transcodedCount++;
                                    } else {
                                        var processingTime = job.inQueueTasks.estimatedTimeToComplete;
                                        $scope.job.status = "Processing file... " + Math.floor((processingTime / 1000) / 60) + " min " + Math.ceil((processingTime / 1000) % 60) + " sec remaining";
                                    }
                                    totalProgress += $scope.job.progress;
                                });
                                $scope.batch.progress = totalProgress / batchSummary.jobSummary.length;
                                $scope.batch.transcodedCnt = transcodedCount;
                            }

                        } else if(message.messageType === 'publish') {

                            var baseFile = message.messageBody,
                                collectionId = baseFile.collectionId,
                                batchId = baseFile.batch.batchId,
                                assetId = message.assetId;

                            if($stateParams.batchId === batchId) {
                                if (baseFile.publishStatus === 'COMPLETE') {
                                    $scope.isProcessing = false;
                                    $state.go('lmsEmbedPlay', {
                                        collectionId: collectionId,
                                        assetId: assetId
                                    });
                                } else if (baseFile.publishStatus === 'ERROR') {
                                    $scope.isProcessing = false;
                                    $scope.isError = true;
                                    $state.go('lmsEmbedPlay', {
                                        collectionId: '000',
                                        assetId: '000'
                                    });
                                }
                            }
                        }
                    }catch(err) {
                        console.log(err.message);
                    }
                };

                request.onClientTimeout = function(response){
                    setTimeout(function(){
                        atmosphereService.subscribe(request);
                    }, request.reconnectInterval);
                };

                atmosphereService.subscribe(request);

            };

            var getUnpublishedJob = function() {

                JobService.GetUnpublished.query({autoPublish: true}, function(unpublishedJobs){

                    angular.forEach(unpublishedJobs, function(job) {
                        var baseFile = job.baseFileEntity,
                            batchId = baseFile.batch.batchId,
                            fileId = baseFile.fileId;

                        if($stateParams.batchId === batchId) {
                            BaseFileService.GetBaseFile.get({id: fileId}, function(file){
                                baseFile.thumbnails = file.thumbnails;
                                baseFile.selectedThumbnail = $filter('filter')(file.thumbnails, { id: baseFile.thumbnailId })[0];
                                baseFile.name = file.name;
                                $scope.fileItem = baseFile;
                            }, function(error){
                                //$scope.errors.push({code: Errors.GET_PREV_FILE_THUMBS, msg: "An error occurred while loading thumbnails for a file uploaded previously. Please try again later or contact your ShareStream Administrator if the error persists."});
                            });
                        }
                    });
                });
            };

            if($stateParams.assetId === '000'){
                $scope.isError = true;
            } else if($stateParams.assetId === '111'){
                $scope.isProcessing = true;
                atmosphereSetup();
                getUnpublishedJob();
            } else {
                AssetService.GetAsset.get({
                    cid: $stateParams.collectionId,
                    aid: $stateParams.assetId
                }, function (asset) {
                    $scope.asset = asset;
                });
            }

        });
    });
